import {
  SIGN_IN,
  SIGN_IN_SUCCESS,
  SIGN_IN_ERROR,
  LOAD_USER,
  LOAD_USER_SUCCESS,
  LOAD_USER_ERROR,
  LOAD_USER_IMAGE,
  LOAD_USER_IMAGE_SUCCESS,
  LOAD_USER_IMAGE_ERROR,
  LOAD_INITIAL_DATA,
  LOAD_INITIAL_DATA_SUCCESS,
  LOAD_INITIAL_DATA_ERROR,
  ADD_REDEMPTION_DATA,
  RESET_ERROR,
  TTLOGGER_EVENTLOG,
  SET_LOCATION,
  TTLOGGER_USER_ID,
  TTLOGGER_SET_USER_ID,
  RESET_PW,
  RESET_PW_SUCCESS,
  RESET_PW_ERROR,
  SEND_MAIL,
  SEND_MAIL_SUCCESS,
  SEND_MAIL_ERROR,
  ACCEPT_PRIVACY,
  ACCEPT_PRIVACY_SUCCESS,
  ACCEPT_TOS,
  ACCEPT_TOS_SUCCESS,
  LOAD_ACCEPTED_PAGES,
  VALIDATION_ERRORS,
  RESET_VALIDATION_ERROR,
} from './constants';


/**
 * Sign in
 */
export function signIn(credentials, targetPage) {
  return {
    type: SIGN_IN,
    credentials,
    targetPage,
  };
}

export function signInSuccess(response) {
  return {
    type: SIGN_IN_SUCCESS,
    response,
  };
}

export function signInError(error) {
  return {
    type: SIGN_IN_ERROR,
    error,
  };
}

/**
 * Reset Password
 */
export function resetPassword(password, token) {
  return {
    type: RESET_PW,
    password,
    token,
  };
}

export function resetPasswordSuccess(response) {
  return {
    type: RESET_PW_SUCCESS,
    response,
  };
}

export function resetPasswordError(error) {
  return {
    type: RESET_PW_ERROR,
    error,
  };
}
/**
 * Send Mail
 */
/**
 * Reset Password
 */
export function sendMail(data) {
  return {
    type: SEND_MAIL,
    data,
  };
}

export function sendMailSuccess(response) {
  return {
    type: SEND_MAIL_SUCCESS,
    response,
  };
}

export function sendMailError(error) {
  return {
    type: SEND_MAIL_ERROR,
    error,
  };
}

/**
 * Load user
 */
export function loadUser() {
  return {
    type: LOAD_USER,
  };
}

export function loadUserSuccess(response) {
  return {
    type: LOAD_USER_SUCCESS,
    response,
  };
}
export function loadAcceptedPages(response) {
  return {
    type: LOAD_ACCEPTED_PAGES,
    response,
  };
}

export function loadUserError(error) {
  return {
    type: LOAD_USER_ERROR,
    error,
  };
}

export function loadUserImage(user) {
  return {
    type: LOAD_USER_IMAGE,
    user,
  };
}

export function loadUserImageSuccess(response) {
  return {
    type: LOAD_USER_IMAGE_SUCCESS,
    response,
  };
}

export function loadUserImageError(error) {
  return {
    type: LOAD_USER_IMAGE_ERROR,
    error,
  };
}

/**
 * Load initial data
 */
export function loadInitialData() {
  return {
    type: LOAD_INITIAL_DATA,
  };
}

export function loadInitialDataSuccess(response) {
  return {
    type: LOAD_INITIAL_DATA_SUCCESS,
    response,
  };
}

export function loadInitialDataError(error) {
  return {
    type: LOAD_INITIAL_DATA_ERROR,
    error,
  };
}

/**
 * Add redeem data
 */
export function addRedemtionData(data) {
  return {
    type: ADD_REDEMPTION_DATA,
    data,
  };
}

/**
 * Reset error
 */
export function resetError() {
  return {
    type: RESET_ERROR,
  };
}

/**
 * TTlogger
 */
export function setTTloggerUserId(ttloggerUserId) {
  return {
    type: TTLOGGER_SET_USER_ID,
    ttloggerUserId,
  };
}

/**
 * TTlogger
 */
export function ttloggerUserID(user) {
  return {
    type: TTLOGGER_USER_ID,
    user,
  };
}

/**
 * TTlogger
 */
export function ttloggerEventLog(name, value) {
  return {
    type: TTLOGGER_EVENTLOG,
    name,
    value,
  };
}

/**
 * TTlogger
 */
export function setLocation(latitude, longitude) {
  return {
    type: SET_LOCATION,
    latitude,
    longitude,
  };
}

export function acceptTos(caregiver) {
  return {
    type: ACCEPT_TOS,
    caregiver,
  };
}
export function acceptTermsSuccess() {
  return {
    type: ACCEPT_TOS_SUCCESS,
  };
}


export function acceptPrivacy(caregiver) {
  return {
    type: ACCEPT_PRIVACY,
    caregiver,
  };
}

export function acceptPrivacySuccess() {
  return {
    type: ACCEPT_PRIVACY_SUCCESS,
  };
}

export function setValidationError(error) {
  return {
    type: VALIDATION_ERRORS,
    customerror: error,
  };
}

export function resetValidationError() {
  return {
    type: RESET_VALIDATION_ERROR,
  };
}
